import isEmail from 'validator/lib/isEmail';

import { getFormattedSouthKoreaPhoneNumber } from '@app/libs/inputFormat';

export default function getFormattedParticipantInfo(name: string, contactInfo: string) {
  const contact = isEmail(contactInfo)
    ? contactInfo
    : getFormattedSouthKoreaPhoneNumber(contactInfo);

  return `${name} (${contact})`;
}
